import { BlurView } from 'expo-blur'
import React, { useEffect } from 'react'
import { Image, StyleSheet, TouchableOpacity, View } from 'react-native'

import { DS } from '../../design-system'
import { useStore } from '../../models'
import { events } from '../../models/analytics/analytics-events'
import RatedStar from './assets/filled-star.svg'
import NonRatedStar from './assets/non-filled-star.svg'

export const RatingBoard = ({
  userFirstName,
  appRating,
  setRating
}: {
  userFirstName: string
  appRating: number
  setRating: (rating: number) => void
}) => {
  const {
    session: { user, updateUserInfo, userEventRating },
    analytics: { setEvent }
  } = useStore()
  const userId = user?._id.toString()

  const [isRatingSubmitted, setIsRatingSubmitted] = React.useState(false)

  useEffect(() => {
    setRating(userEventRating)
  }, [setRating, userEventRating])

  return (
    <BlurView intensity={80} tint="light" style={styles.container}>
      <DS.Frame bg="Global/White" style={styles.frameContainer}>
        <Image source={require('./assets/rating-logo.png')} style={styles.ratingLogo} />
        <DS.Text variant="Heading 3/Medium" color="Global/Black" style={styles.ratingBoardTitle}>
          {`Hope you had fun at the event ${userFirstName}!`}
        </DS.Text>
        <DS.Frame style={{ marginTop: DS.spacing[16] }}>
          <DS.Text variant="Body Medium/Regular" color="Global/Black" style={styles.ratingBoardSubtitle}>
            How would you rate the experience?
          </DS.Text>
          <View style={{ gap: 16 }}>
            <View style={styles.handRankings}>
              {[1, 2, 3, 4, 5].map((item, index) => {
                return (
                  <TouchableOpacity key={`rate-${item}`} onPress={() => setRating(item)}>
                    {appRating <= index ? <NonRatedStar /> : <RatedStar />}
                  </TouchableOpacity>
                )
              })}
            </View>
          </View>
          {appRating > 0 && !isRatingSubmitted && (
            <DS.Button
              variant={'Large/Primary'}
              type={'On Light'}
              onPress={async () => {
                setEvent(events.homescreen.post_event_rating, {
                  userId,
                  rating: appRating
                })
                setIsRatingSubmitted(true)
                await updateUserInfo({ userEventRating: appRating })
              }}
              style={styles.submitRatingButton}
            >
              Submit Rating
            </DS.Button>
          )}
          {appRating > 0 && isRatingSubmitted && (
            <DS.Text variant="Body Medium/Regular" textAlign="center">
              Thanks for rating
            </DS.Text>
          )}
        </DS.Frame>
      </DS.Frame>
    </BlurView>
  )
}

const styles = StyleSheet.create({
  container: {
    padding: DS.spacing[16],
    backgroundColor: 'rgba(255, 255, 255, 0.50)',
    borderRadius: 12,
    overflow: 'hidden'
  },
  frameContainer: {
    padding: DS.spacing[16],
    borderRadius: 12
  },
  handRankings: {
    marginTop: 16,
    paddingVertical: 16,
    paddingHorizontal: 12,
    gap: 8,
    backgroundColor: 'transparent',
    borderRadius: 40,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: DS.palette['Brand/Light Grey'],
    width: '80%',
    alignSelf: 'center'
  },
  submitRatingButton: {
    marginTop: 8,
    alignSelf: 'center',
    width: '50%'
  },
  ratingLogo: {
    alignSelf: 'center',
    width: 48,
    height: 48
  },
  ratingBoardTitle: {
    textAlign: 'center',
    marginTop: 15
  },
  ratingBoardSubtitle: {
    textAlign: 'center',
    marginTop: 15
  }
})
